import React from "react";
import { useNavigate } from "react-router-dom";
import ModalShell from "./ModalShell";

interface StatusModalProps {
    isOpen: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    status: "success" | "error";
    content: string;
    /** Optional title override. Defaults to a sensible per-status heading. */
    title?: string;
}

/**
 * A two-state feedback dialog.
 * - "success": confirms the action and redirects the user back on close.
 * - "error":   surfaces the message and keeps the user on the page to retry.
 * Both states share the same layout, differing only by tone and button label.
 */
const StatusModal: React.FC<StatusModalProps> = ({ isOpen, setOpen, status, content, title }) => {
    const navigate = useNavigate();
    const isSuccess = status === "success";

    const handleClose = () => {
        setOpen(false);
        if (isSuccess) {
            navigate(-1); // Return to settings only after a successful update.
        }
    };

    return (
        <ModalShell
            open={isOpen}
            onClose={handleClose}
            size="sm"
            tone={isSuccess ? "success" : "error"}
            title={title ?? (isSuccess ? "Success" : "Something went wrong")}
            actions={
                <button className="btn btn-primary" onClick={handleClose}>
                    {isSuccess ? "Continue" : "Try again"}
                </button>
            }
        >
            {content && <p>{content}</p>}
        </ModalShell>
    );
};

export default StatusModal;
